module.exports = __webpack_public_path__ + "static/media/thunder.7142c78b.svg";